
import { Box, Typography } from '@mui/material'
import React from 'react'
import DevLink from './DevLink'

const Name = () => {
  return (
    <Box p={5} sx={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'normal', height:{sm:'10vh',md:'85vh'}, marginTop:'2px'}}>
        <Typography variant='h4' color={'#E0E0E0'}>Hi, I am</Typography>
        <Box maxWidth={'60%'} mx={'auto'}>
        <Typography variant='h2' mt={3}  align='center' color={'#70FF00'} fontWeight={'bolder'}>&lt; Thomson Cleetus /&gt;</Typography>
        <Typography variant='h6' mt={2} align='center' color={'#E0E0E0'}>Front-end Developer</Typography>
        </Box>
        <DevLink/>
    </Box>

  )
}

export default Name